import { render, staticRenderFns } from "./GamesListTable.vue?vue&type=template&id=572f35ab&scoped=true"
import script from "./GamesListTable.vue?vue&type=script&lang=js"
export * from "./GamesListTable.vue?vue&type=script&lang=js"
import style0 from "./GamesListTable.vue?vue&type=style&index=0&id=572f35ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572f35ab",
  null
  
)

export default component.exports